import { render, staticRenderFns } from "./cnpj-input.vue?vue&type=template&id=c674097c"
import script from "./cnpj-input.vue?vue&type=script&lang=js"
export * from "./cnpj-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports